import { AJOUTE_URL_SOCIETE, SUPRIMER_URL_SOCIETE } from '../types/typeUrlSociete';
const urlSociete = [];
const UrlSocieteReducer = (state = urlSociete, action) => {
    if (localStorage.getItem('urlSociete')) {
        state = localStorage.getItem('urlSociete');
    }
    switch (action.type) {
        case AJOUTE_URL_SOCIETE:
            state = action.payload;
            return state;
            break;
        case SUPRIMER_URL_SOCIETE:
            return state = [];
        default:
            return state;

    }
}

export default UrlSocieteReducer;